module.exports = __webpack_public_path__ + "static/img/tea_app_ios.64d75b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tea_app_ios.png
// module id = qHvm
// module chunks = 53